import { render, staticRenderFns } from "./authorizer-info.html?vue&type=template&id=4db2b74e&scoped=true&external"
import script from "./authorizer-info.js?vue&type=script&lang=js&external"
export * from "./authorizer-info.js?vue&type=script&lang=js&external"
import style0 from "./authorizer-info.scss?vue&type=style&index=0&id=4db2b74e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db2b74e",
  null
  
)

export default component.exports